import {DynamicTextType} from '@buncha/batchDetails/types';
import {OrderItem} from './ItemScanner';
import {OrderItem as OrderItemHome} from '@buncha/home/types';

/* eslint-disable no-shadow */
export enum SubstitutionChoice {
  byShopper = 'byShopper',
  byBuyer = 'byBuyer',
  noSubstitution = 'noSubstitution',
  none = 'none',
  anyBrand = 'anyBrand',
  meijerBrand = 'meijerBrand',
  nationalBrand = 'nationalBrand',
}

export enum SubstitutionMode {
  approvedThroughApp = 'approvedThroughApp',
  approvedOverCallAfterRequestSend = 'approvedOverCallAfterRequestSend',
  approvedOverCallBeforeRequestSend = 'approvedOverCallBeforeRequestSend',
}

export interface ItemLocationInformation {
  aisle: string;
  catalogItemId: number;
  esIndex: string;
  foundHere: string;
  id: number;
  itemForReplacement: any;
  locationImage: string;
  orderItemId: number;
  price: number;
  reportMissing: number;
  storeContext: string;
  upcOrderItemId: number;
}

export interface SubstitutionOptions {
  id: number;
  name: string;
}

export enum OrderSubstitutionPreference {
  ALLOWED = 'ALLOWED',
  NOT_ALLOWED = 'NOT_ALLOWED',
}

export interface OrderItemAttribute {
  weight: number;
  units: string;
}

export interface Buyers {
  id: number;
  firstName: string;
  lastName: string;
  isVip: boolean;
  phoneNumber: string;
  conversationId: string;
  isAdjacentOOSItem?: boolean;
  hasBunchaClub: boolean;
  hasNewCustomer: boolean;
  orderItemId: number;
  orderId: number;
  quantity: number;
  substitutedBy: any;
  hasSubstitutionRequest: boolean;
  substitutionChoice: SubstitutionChoice;
  substitutionOptions: SubstitutionOptions[];
  updatedPricePerQuantity: number;
  updatedQuantity: number;
  isNSC2Item: boolean;
  orderItemAttribute: OrderItemAttribute;
  order: {
    buyerChatInfo: {
      isVisible: boolean;
      conversationId: string;
      expiresIn: string;
    };
    buyer?: {
      isVip?: boolean;
    };
    substitutionPreference: OrderSubstitutionPreference;
  };
  itemNote: string | null;
  substitutionNote: string;
  priceTag: boolean;
}

export interface State {
  item?: OrderItem;
  buyersForItem: Buyers[];
  reasonsForDropping: any[];
  itemNotes: string;
  hasAnyBuyerInstructions: boolean;
  itemLocationInformation?: ItemLocationInformation;
  orderItemIds: number[];
  constants: any;
  storeCategories: string[];
}

export interface StoreForItemDetail {
  id: number;
  elasticSearchIndex: string;
  storeMasterId: number;
}

export interface RunForItemDetail {
  id: number;
  store: StoreForItemDetail;
}

export interface GetRunForItemDetailResponse {
  getRun: RunForItemDetail;
}

export interface DynamicTextsProps {
  buttonText?: string;
  onButtonClick?: () => any;
  type?: DynamicTextType[];
  orderId?: number;
}

export interface IsEligibleForAdjacentOOSArgs {
  catalogItemId: number;
  orderId: number;
  orderItemId: number;
  runId: number;
}

export interface GetBuyersForItemsResponse {
  itemWithBuyersAndSub: Buyers[];
}

export interface BuyerChatInfo {
  conversationId: string;
  isVisible: boolean;
}

export interface FetchMaskedNumberVariable {
  orderId: number;
  runId: number;
}

export interface FetchMaskedNumberResponse {
  fetchMaskedNumber: string | null;
}

export interface UpdateOrderItemQtyVariables {
  orderItemId: number;
  itemQuantity: number;
  runId: number;
}

export interface UpdateOrderItemQuantityResponse {
  updateOrderItemQuantity: OrderItemHome;
}

export interface GetStoreCategoriesResponse {
  categoryDropdown: string[];
}

export interface UpdateCategoryResponse {
  updateCategoryByShopper: boolean;
}

export interface OOSCatalogItem {
  id: number;
  name: string;
  itemImageUrl: string;
  price: number;
  quantity?: number;
}

export interface AdjOOSData {
  isEligible: boolean;
  conversationId: string;
  newCatalogItem: OOSCatalogItem;
  originalCatalogItem: OOSCatalogItem;
  newShopper: {
    id: number;
    firstName: string;
    phoneNumber: string;
  };
}

export interface IsEligibleForAdjacentOOSResponse {
  isEligibleForAdjacentOOS: {
    data: {
      V100: AdjOOSData;
    };
  };
}
